import React from "react";
import "./Buttons.scss";

interface ButtonsProps {
  buttonTitle?: string;
  onClick?: any;
  disabled?: any;
  buttonType: string;
  children?: JSX.Element;
  className?: any;
  style?: object;
}

const Buttons: React.FC<ButtonsProps> = (props) => {
  switch (props.buttonType) {
    case "DropDownnormalButton":
      return (
        <button
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          className={`dropdown-toggle buttonClassNormal ${props.className}`}
          onClick={props.onClick}
        >
          {props.buttonTitle}
        </button>
      );
    case "normalButton":
      return (
        <button
          className={`buttonClass ${props.className}`}
          onClick={props.onClick}
          type="submit"
        >
          {props.buttonTitle}
        </button>
      );
    case "normalButtonBlue":
      return (
        <button
          className={`buttonBlue ${props.className}`}
          onClick={props.onClick}
          type="submit"
        >
          {props.buttonTitle}
        </button>
      );
    case "normalButtonWhite":
      return (
        <button
          disabled={props.disabled}
          className={`buttonClassNormal ${props.className}`}
          onClick={props.onClick}
          type="submit"
        >
          {props.buttonTitle}
        </button>
      );
    case "iconButton":
      return (
        <button
          className={`iconButton ${props.className}`}
          onClick={props.onClick}
        >
          {props.children}
        </button>
      );
    case "normalCloseButton":
      return (
        <button
          disabled={props.disabled}
          className={`buttonClassClose ${props.className}`}
          onClick={props.onClick}
          type="submit"
        >
          {props.buttonTitle}
        </button>
      );

    default:
      return <div>Wrong</div>;
  }
};

export default Buttons;
